import { z } from 'zod';
export const OrderBy = {
  CERTIFICATION_NAME: 'CERTIFICATION_NAME',
  CERTIFICATION_NUMBER: 'CERTIFICATION_NUMBER',
  LAST_RENEWAL_DATE: 'LAST_RENEWAL_DATE',
  VALID_TO: 'VALID_TO',
  RENEWAL_DEADLINE: 'RENEWAL_DEADLINE'
} as const;
export const MyCertificationType = {
  CERTIFICATION: 'CERTIFICATION',
  ARCHIVED: 'ARCHIVED'
} as const;
export type MyCertificationType = (typeof MyCertificationType)[keyof typeof MyCertificationType];
export const MyCertificationsSearchSchema = z.object({
  sortOrder: z.enum(['asc', 'desc']).default('asc').optional(),
  sortColumn: z.union([z.nativeEnum(OrderBy), z.enum(['certificationName', 'certificationNumber', 'lastRenewalDate', 'validTo', 'renewalDeadline'])]).optional(),
  freeText: z.string().optional(),
  page: z.number().default(1),
  pageSize: z.number().default(100),
  certificationType: z.nativeEnum(MyCertificationType).default(MyCertificationType.CERTIFICATION).optional()
});